import { computed, ref, watch } from 'vue-demi';
const {
    rem: { parseStyle }
} = require('@futuweb/fego-bridge');
const { useZIndex } = require('@fegobull/webapi').use;
/**
 *
 * 处理弹窗样式
 * @param {*} props
 * @return {*} 弹窗样式
 */
export default function useModalStyle(props, visible) {
    const zIndex = ref(0);
    if (props.zIndex !== 0 && !props.zIndex) {
        zIndex.value = useZIndex();
        watch(visible, () => {
            if (visible.value) {
                zIndex.value = useZIndex();
            }
        });
    } else {
        zIndex.value = props.zIndex;
    }

    // 处理弹窗层级
    const zIndexStyle = computed(() => {
        return { zIndex: zIndex.value };
    });
    // 遮罩样式
    const fixedMaskStyle = computed(() => {
        const r = {
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            position: 'fixed',
            background: props.fixedMaskColor || 'transparent'
        };
        return parseStyle(r);
    });
    // 处理内容背景
    const contentStyle = computed(() => {
        const r = {
            backgroundColor: props.contentBackgroundColor || 'transparent'
        };
        return parseStyle(r);
    });

    return {
        zIndexStyle,
        fixedMaskStyle,
        contentStyle
    };
}
